import React, { Component } from 'react';
import { Helmet } from "react-helmet"
import Header from '../../Layout/Header'

import Wave from '../../Components/Wave'
import './index.scss'

class Offer extends Component {
	state = {
		example: 1
	}
	render() {
		let backgroundImage = {}
		if (this.state.example === 1)
			backgroundImage = { backgroundImage: `url(${require('./example-1.jpg')})` }
		if (this.state.example === 2)
			backgroundImage = { backgroundImage: `url(${require('./example-2.jpg')})` }
		if (this.state.example === 3)
			backgroundImage = { backgroundImage: `url(${require('./example-3.jpg')})` }
		
		return (
			<div className="page-offer">
				<Helmet>
					<title>Moshi Offer</title>
                </Helmet>  
				<Header
					seoTitle="Moshi Offer"
					title={<div>is online marketing <br /><strong>right for your business</strong></div>}
				/>
				<div className="entry-content">
					<div className="container-fluid">
						<h2 className="outline text-center">
							<div className="line"></div>
							<div className="title">We are offering a 12 month package that will seriously get your business online</div>
						</h2>
						<div className="row">
							<div className="col-lg-1"></div>
							<div className="col-lg-4">
								<img src={require('./flyier.png')} alt="Moshi Fliers" width="100%" />
							</div>
							<div className="col-lg-6">
								<div className="tagline">
									If you’re looking for our 3 Moshi-Designed Websites to support a Google Adwords Online Marketing Campaign then you’ve come to the right place!
								</div>
								<p>
									<strong>
										You’ve probably already seen our online marketing flyer, but if you haven’t you can download it by clicking <a href={require('./MMM-Sites.pdf')}>here</a>.
									</strong>
								</p>
								<p>
									To support getting your business online we’ve developed 3 unique Moshi driven templates that can be customised to reflect your brand. We do this through changing the logo, photography and colours across these templates. 
								</p>
								<p>
									We’ve worked with hundreds of businesses and understand the barriers to entry when it comes to maximising your presence online. With this in mind we’ve developed these 3 themes to work fast and be responsive across different devices. You can view the different sites below.
								</p>
							</div>
						</div>
					</div> 	

					<div className="container-fluid">
					<h2 className="outline text-center pull-down">
						<div className="line"></div>
						<div className="title">Which Moshi Website would you like to view?
							<span className={this.state.example === 1 ? "active" : ""} onClick={()=>this.setState({ example: 1 })}>Website #1</span>
							<span className={this.state.example === 2 ? "active" : ""} onClick={()=>this.setState({ example: 2 })}>Website #2</span>
							<span className={this.state.example === 3 ? "active" : ""} onClick={()=>this.setState({ example: 3 })}>Website #3</span>
						</div>
						</h2>
					</div>

					<section className="the-team" style={backgroundImage}>
						<Wave className={`top over`} />
						<Wave className={`bottom over `} />
						<div className="container-fluid">
							
							<div className="row">
								<div className="col-lg-1"></div>
								<div className="col-lg-4">
									<div className="holder-overlay">
										<h3>Moshi Website #{this.state.example}</h3>
										<p>This theme incorporates dynamic angles, titles with impact and high contrast colour themes to deliver a stunning yet bold website presence. The style of images can be changed to suit a specific industry and colours linked to support your brand.</p>

										<p>This theme was developed with the following industries in mind:</p>
										<ul className="with-icons">
											<li>High Impact Businesses</li>
											<li>Sports Performance</li>
											<li>Extreme Sports</li>
											<li>Dynamic Creative Businesses</li>
											<li>Architecture / Interior Design</li>
										</ul>
										<a href={`http://template${this.state.example}.moshimoshi.marketing/`} target="_blank" className="btn">Live Site Preview <i className="fa fa-laptop"></i></a>
									</div>
								</div>
							</div>
							
						</div>
					</section>
				</div>
			</div>
		);
	}
}

export default Offer;


// WEBPACK FOOTER //
// ./src/Pages/Offer/index.js